module.exports = __webpack_public_path__ + "static/img/surface-post.e3340c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/facilities/surface-post.jpg
// module id = 603
// module chunks = 0